import { QtmButton } from '@qtm/react';
import { useGetAreasQuery } from 'api/AreasEndPoints';
import { useGetConstellationsResultsQuery } from 'api/ConstellationResultEndPoints';
import { useGetUsageLogsQuery } from 'api/StatisticsEndPoints';
import { useGetUserQuery } from 'api/UsersEndPoints';
import dayjs from 'dayjs';
import FileSaver from 'file-saver';
import { useAppSelector } from 'hooks/redux';
import Papa from 'papaparse';
import { useParams } from 'react-router-dom';
import { ConfigContent, ConnectionContent, CriteriaContent } from 'shared/model/usageLog.model';

const debug = true;

const EXPORT_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
interface ExportStat {
  date: string;
  type: string;
  content: string;
}

const ExportUserStatBtn = () => {
  const from = useAppSelector(state => state.userStats.from);
  const to = useAppSelector(state => state.userStats.to);

  const { id } = useParams();

  const { data: user } = useGetUserQuery(Number(id));

  const { data: areaData } = useGetAreasQuery({
    fields: ['id', 'name'],
  });

  const areas = areaData ?? [];

  const { data } = useGetUsageLogsQuery({
    where: {
      userId: Number(id),
      date: {
        between: [from, to],
      },
    },
    order: ['date desc'],
  });

  const logs = data ?? [];

  const resultIds = logs.reduce((acc: number[], current) => {
    if (current.type === 'CONFIG_SELECTED') {
      const content = current.content as ConfigContent;
      acc.push(content.resultId);
    }
    return acc;
  }, []);

  const { data: dataConstellations, isLoading } = useGetConstellationsResultsQuery(
    {
      include: ['constellationConfiguration'],
      where: {
        id: {
          inq: resultIds,
        },
      },
    },
    {
      skip: resultIds.length === 0,
    },
  );

  const results = dataConstellations ?? [];

  if (logs.length === 0 || !user || !debug) {
    return null;
  }

  const exportStats = () => {
    if (!user) {
      return;
    }

    const fromDate = dayjs(from);
    const toDate = dayjs(to);
    const fromStr = fromDate.format('DD/MM/YYYY');
    const toStr = toDate.format('DD/MM/YYYY');

    const fileName = `${fromStr}_${toStr}_${user.email}_export.csv`;

    const json = logs.reduce((acc: ExportStat[], current) => {
      const date = dayjs(current.date).format(EXPORT_DATE_FORMAT);
      const type = current.type;

      let contentStr = '';
      if (type === 'CONNECTION') {
        const contentConnection = current.content as ConnectionContent;
        contentStr = 'timeSpent: ' + contentConnection.timespent;
      } else if (type === 'CRITERIA') {
        const contentCriteria = current.content as CriteriaContent;
        contentStr = `area: ${areas.find(a => a.id === contentCriteria.areaId)?.name}, ratio: ${contentCriteria.ratio}, revisitTime: ${contentCriteria.revisitTime}`;
      } else if (type === 'CONFIG_SELECTED') {
        const contentConfig = current.content as ConfigContent;
        const result = results.find(resultIds => resultIds.id === contentConfig.resultId);
        if (result) {
          contentStr = `constellation: ${result.constellationConfiguration?.name}`;
        }
      }

      const toAdd = {
        date,
        type,
        content: contentStr,
      };

      acc.push(toAdd);

      return acc;
    }, []);

    const output = Papa.unparse(json);

    const blob = new Blob([output], { type: 'text/csv;charset=utf-8;' });
    FileSaver.saveAs(blob, fileName);
  };

  return (
    <div style={{ position: 'absolute', right: 0, top: '10%' }}>
      <QtmButton onClick={exportStats}>Export</QtmButton>
    </div>
  );
};

export default ExportUserStatBtn;
